'use client'
import { motion, useInView } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { GameRecordList } from '../constant'

interface Props {
  className?: string
  titleClass?: string
  descClass?: string
}

export function HomeRecords({ className, titleClass, descClass }: Props) {
  const delay = 0.3
  const ref = useRef(null)
  const isInView = useInView(ref, { margin: '-100px 0px' })

  const [animationKey, setAnimationKey] = useState(0)

  useEffect(() => {
    setAnimationKey((prev) => prev + 1)
  }, [isInView])

  return (
    <div ref={ref} className={`flex justify-between ${className}`}>
      {GameRecordList.map(({ title, description }, index) => (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : false}
          transition={
            isInView
              ? {
                  delay: (index + 1) * delay,
                  duration: 0.6,
                  ease: 'easeOut',
                  type: 'spring',
                  stiffness: 120, // 控制弹跳感
                }
              : { duration: 0 }
          }
          className="flex-y-center grow"
          key={`${index}_${animationKey}`}
        >
          <motion.div
            className={`mb-4 font-semibold tracking-[-5px] ${titleClass}`}
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : false}
            transition={
              isInView
                ? {
                    delay: (index + 1) * delay,
                    duration: 0.8,
                    type: 'spring',
                    stiffness: 100,
                  }
                : { duration: 0 }
            }
          >
            {title}
          </motion.div>
          <motion.div
            className={`font-medium ${descClass}`}
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : false}
            transition={isInView ? { delay: (index + 1) * delay + 0.2, duration: 0.6 } : { duration: 0 }}
          >
            {description}
          </motion.div>
        </motion.div>
      ))}
    </div>
  )
}
